// The `CustomerServiceTastic` component fetches and passes customer service data, content templates,
// and FAQs to the `CustomerService` component for rendering. It is designed to handle and display customer
// service-related information dynamically.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import CustomerService from 'components/commercetools-ui/organisms/customer-services';
import { ServiceData } from 'types/next';

const CustomerServiceTastic = ({ data }: TasticProps<ServiceData>) => {
  const services = data?.data?.dataSource?.customerService;
  const serviceContents = data?.data?.dataSource?.contents;
  const templateContents = data?.data?.dataSource?.templateContents;
  const faqs = data?.data?.dataSource?.faqs;

  return (
    <>
      <CustomerService
        customerService={services}
        serviceContents={serviceContents}
        templateContents={templateContents}
        faqs={faqs}
      />
    </>
  );
};

export default CustomerServiceTastic;
